import { HStack, Tile, IconButton, Text, DataList, DataItem } from '@cad-arc';
import { format } from 'date-fns';
import { UnitHistoryEventView } from '@mark43/cad-api';
import { FR_EVENT_DETAILS_TABS } from '../../../fr-event-details-page/constants';
import { FR_UNIT_HISTORY_PATH } from '../../../router/constants';
import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { UnitHistoryForm } from '../../types';
import { useOpenEvent } from '../../../common/hooks/use-open-event';

export function IncludedEventTile({
    event,
    onClick,
}: {
    event: UnitHistoryEventView;
    onClick: () => void;
}): React.ReactElement {
    const { form } = useIntegratedForm<UnitHistoryForm>();

    const currentFormSearchData = form.getValues();

    const locationState = {
        previousLocationPathname: FR_UNIT_HISTORY_PATH,
        unitHistorySearchData: { ...currentFormSearchData },
    };

    const handleOpenEvent = useOpenEvent();

    return (
        <Tile
            title={
                <HStack justifyContent="space-between">
                    <HStack>
                        <Text variant="headingXs">{event.agencyEventNumber}</Text>
                        <IconButton
                            variant="ghost"
                            icon="OpenNewWindow"
                            aria-label="Open event"
                            size="sm"
                            style={{ marginLeft: '4px' }}
                            onClick={() =>
                                handleOpenEvent({
                                    eventId: event.id,
                                    frEventDetailsTabName: FR_EVENT_DETAILS_TABS.NARRATIVE,
                                    locationState,
                                })
                            }
                        />
                    </HStack>
                    <Text variant="caption" color="secondary">
                        {format(
                            new Date(event.earliestRetrievedRelatedUnitHistoryItemCreatedDateUtc),
                            'MM/dd HH:mm'
                        )}
                    </Text>
                </HStack>
            }
            description={
                <DataList>
                    <DataItem dataKey="Location">{event.eventLocation}</DataItem>
                    <DataItem dataKey="CFS">{event.cfsCodeAndDescription}</DataItem>
                </DataList>
            }
            onClick={onClick}
        />
    );
}
